import "unpoly";

const up = window.up;

// Watch form checkboxes to handle the special checkbox logic for child boxes
up.compiler("#org-region-filters", function (filters) {
  let allCheck = filters.querySelector("#regions_all");
  let regions = filters.querySelectorAll(
    "input.form-check-input:not(#regions_all)",
  );

  up.on(allCheck, "change", function () {
    if (allCheck.checked) {
      regions.forEach((input) => (input.checked = false));
    }
  });

  up.on(regions, "change", function () {
    allCheck.checked = !Array.from(regions).some((input) => input.checked);
  });
});

// Reset regions to their default state whenever the country changes, so a
// previous country's stale region selections aren't submitted along with it.
up.compiler("#location-filters", function (filters) {
  let countrySelect = filters.querySelector("#country");

  up.on(countrySelect, "change", function () {
    filters
      .querySelectorAll("#org-region-filters input[type=checkbox]")
      .forEach((input) => {
        input.checked = false;
      });
  });
});

up.compiler(".parent-wrapper", function (parentWrapper) {
  let parentInput = parentWrapper.querySelector(
    ":scope > input.form-check-input",
  );
  let childInputs = parentWrapper.querySelectorAll(
    ".child-wrapper input.form-check-input",
  );

  up.on(parentInput, "change", function () {
    childInputs.forEach(
      (childInput) => (childInput.checked = parentInput.checked),
    );
    up.submit(parentInput.closest("form"));
  });

  up.on(childInputs, "change", function () {
    parentInput.checked = Array.from(childInputs).every(
      (childInput) => childInput.checked,
    );
    up.submit(parentInput.closest("form"));
  });
});
